import React from "react";
import {  PropagateLoader } from "react-spinners";

export default function Loader() {
  return (
    <div
     
      className="h-[77vh] flex items-center justify-center"
    >
      <PropagateLoader size="15px" color="#fbb03b" />
    </div>
  );
}